function paddLeft(number:number, scale:number) : string {
  if (scale == null) scale = 0;
  const base = Math.pow(10, scale);
  if (number >= base) return number.toString();
  return (base + number).toString().substr(1);
}

export function formatDate(date: Date) : string {
  return `${date.getFullYear()}-${paddLeft(date.getMonth() + 1, 2)}-${paddLeft(
    date.getDate(),
    2,
  )}`;
}

export function formatTime(date: Date, includeSeconds: boolean = false) : string {
  if (includeSeconds === true) {
    return `${paddLeft(date.getHours(), 2)}:${paddLeft(
      date.getMinutes(),
      2,
    )}:${paddLeft(date.getSeconds(), 2)}`;
  }
  return `${paddLeft(date.getHours(), 2)}:${paddLeft(date.getMinutes(), 2)}`;
}

export function formatRecordDate(date?: Date) : string {
  if (!date) return 'n/a';
  return `${formatDate(date)} ${formatTime(date, true)}`;
}

export function formatUploadHeaderDate(date: Date) : string {
  return `${formatDate(date)} at ${formatTime(date)}`;
}

export function formatTimestampInterval(fromTimestamp:number, toTimestamp:number) : string  {
    var delta = (toTimestamp - fromTimestamp) / (60 * 1000);
    return [
        [30 * 24 * 60,'months'],
        [7 * 24 * 60,'weeks'],
        [24 * 60,'days'],
        [60,'minutes']
    ].map(factor => {
        var result = Math.floor(delta / (factor[0] as number))
        delta = delta % (factor[0] as number);
        return result > 0 ? `${result} ${factor[1]}` : '';
    }).filter(l => l.length > 0).slice(0,2).join(" ")
}
